// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1NcWa","footer":"styles_footer__1ri0c","passCodeTooltip":"styles_passCodeTooltip__T1_tK"};